import { Camera, Flame, Lock, Network, Package, Radio } from 'lucide-react';
import { storeMetrics } from './storeMetrics';

export const heroSlides = [
  {
    id: 1,
    tag: 'CCTV',
    headline: 'Cámaras y grabadoras del almacén central',
    body: 'Mismo inventario que sale a obra. Existencia en pantalla, sin cotizar por teléfono.',
    cta: { label: 'Ver CCTV', to: '/catalogo?categoria=cctv' },
    ctaSecondary: { label: 'Ver kits', to: '/kits' },
    gradient: 'from-brand-950 via-brand-900 to-surface-950',
    accent: 'bg-brand-500/20',
  },
  {
    id: 2,
    tag: 'Kits',
    headline: 'Kits listos para instalar',
    body: `CCTV e intrusión con piezas ya armadas. Desde $${storeMetrics.kitsDesdeMxn.toLocaleString('es-MX')} MXN — ves qué trae cada kit y el total antes de comprar.`,
    cta: { label: 'Ver kits', to: '/kits' },
    ctaSecondary: { label: 'Catálogo completo', to: '/catalogo' },
    gradient: 'from-surface-950 via-brand-950 to-surface-900',
    accent: 'bg-brand-400/10',
  },
  {
    id: 3,
    tag: 'Intrusión y acceso',
    headline: 'Paneles, sensores y lectores',
    body: 'DSC, Hikvision y equipos que ya instalamos en campo. Pide factura con RFC en el checkout.',
    cta: { label: 'Intrusión', to: '/catalogo?categoria=intrusion' },
    ctaSecondary: { label: 'Control de acceso', to: '/catalogo?categoria=acceso' },
    gradient: 'from-surface-950 via-surface-900 to-brand-950',
    accent: 'bg-brand-400/10',
  },
];

export const categories = [
  { slug: 'cctv', label: 'CCTV', icon: Camera, color: 'bg-surface-100 text-surface-700' },
  { slug: 'intrusion', label: 'Intrusión', icon: Radio, color: 'bg-surface-100 text-surface-700' },
  { slug: 'acceso', label: 'Acceso', icon: Lock, color: 'bg-surface-100 text-surface-700' },
  { slug: 'incendio', label: 'Incendio', icon: Flame, color: 'bg-surface-100 text-surface-700' },
  { slug: 'redes', label: 'Redes', icon: Network, color: 'bg-surface-100 text-surface-700' },
  { slug: 'accesorios', label: 'Accesorios', icon: Package, color: 'bg-surface-100 text-surface-700' },
];

/** Carruseles del home: un bloque por línea de producto */
export const categoryCarousels = [
  { slug: 'cctv', title: 'Cámaras y videovigilancia', subtitle: 'CCTV' },
  { slug: 'intrusion', title: 'Intrusión y alarmas', subtitle: 'Paneles, sensores y comunicadores' },
  { slug: 'acceso', title: 'Control de acceso', subtitle: 'Lectores, torniquetes y biométricos' },
  { slug: 'incendio', title: 'Detección de incendio', subtitle: 'Detectores y centrales' },
  { slug: 'redes', title: 'Redes y conectividad', subtitle: 'Switches, cableado y PoE' },
  { slug: 'accesorios', title: 'Accesorios', subtitle: 'Soportes, fuentes y complementos' },
] as const;

export const promoBanners = [
  {
    title: 'Envío a todo México',
    desc: 'Mandamos por Estafeta o DHL. Te enviamos la guía cuando salga de nuestro almacén.',
    linkText: 'Ver productos',
    to: '/catalogo',
    theme: 'dark' as const,
  },
  {
    title: `Kits desde $${storeMetrics.kitsDesdeMxn.toLocaleString('es-MX')}`,
    desc: 'Cámaras + grabador, o panel + sensores: piezas definidas y un precio total en el carrito.',
    linkText: 'Ver kits',
    to: '/kits',
    theme: 'brand' as const,
  },
  {
    title: '¿Necesitas factura?',
    desc: 'Al pagar puedes capturar tus datos fiscales y te enviamos tu factura electrónica.',
    linkText: 'Ir al catálogo',
    to: '/catalogo',
    theme: 'light' as const,
  },
];

export const compraConfianzaItems = [
  {
    title: 'Existencia en pantalla',
    desc: 'Si un producto muestra piezas disponibles, es lo que podemos surtir de nuestro almacén.',
  },
  {
    title: 'Confirmación de tu pedido',
    desc: 'Al terminar la compra recibes un folio. Te escribimos para confirmar pago y forma de envío.',
  },
  {
    title: 'Factura cuando la pidas',
    desc: 'Marca que necesitas factura en el checkout, ingresa tus datos y te la hacemos llegar.',
  },
];
